import CustomerList from '../components/customer/List'
import CustomerCreate from '../components/customer/Create'
import CustomerUpdate from '../components/customer/Update'

export default [
  {
    name: 'Customer',
    path: '/customers/',
    component: {template: '<router-view></router-view>'},
    redirect: {name: 'CustomerList'},
    children: [
      {name: 'CustomerList', path: '', component: CustomerList},
      {name: 'CustomerCreate', path: 'create', component: CustomerCreate},
      {name: 'CustomerUpdate', path: 'edit/:id', component: CustomerUpdate}
    ]
  }
]
